//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Swiper from "swiper";
export default {
  name: "project",
  data() {
    return {
      idx: 2,
      stu: 0,
      swindex: -1,
      mskindex: -1,
      goodsstatus: 0,
      details: {},
      priject_tab: [
        {
          text: "再建项目",
          status: 0,
        },
        {
          text: "历史项目",
          status: 1,
        },
        {
          text: "中标项目",
          status: 2,
        },
      ],
      project_list: [],
      project: [],
      banner: [
        {
          img: require("../assets/images/project_banner1.png"),
        },
        {
          img: require("../assets/images/project_banner2.png"),
        },
        {
          img: require("../assets/images/project_banner3.png"),
        },
      ],
      nav: [
        {
          text: "首页",
          status: "0",
        },
        {
          text: "关于中启",
          status: "1",
        },
        {
          text: "工程案例",
          status: "2",
        },
        {
          text: "新闻中心",
          status: "3",
        },
        {
          text: "业务中心",
          status: "4",
        },
        {
          text: "人力资源",
          status: "5",
        },
        {
          text: "联系我们",
          status: "6",
        },
      ],
    };
  },
  updated: function () {
    new Swiper(".swiper1", {
      spaceBetween: 30,
      centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".bannerpage",
        clickable: true,
      },
    });
    new Swiper(".swiper2", {
      slidesPerView: 3,
      slidesPerColumn: 2,
      spaceBetween: 30,
      pagination: {
        el: ".page2",
        clickable: true,
      },
      navigation: {
        nextEl: ".next2",
        prevEl: ".prev2",
      },
    });
  },
  mounted() {
    const _this = this;
    _this.getlist();
  },
  methods: {
    //获取具体列表
    getlist() {
      const _this = this;
      _this.$post("/header/project/fetch").then((res) => {
        console.log(res);
        _this.details = res.data;
        _this.project = res.data.statusAllVo[0].subList;
        _this.project_list = res.data.statusAllVo[0].subList[0].projectlist;
      });
    },
    collect_click() {
      alert("请按住Ctrl+D收藏网站");
    },
    //导航跳转
    rout(a) {
      if (a == 0) {
        this.$router.push({
          path: "/",
        });
      } else if (a == 1) {
        this.$router.push({
          path: "/about",
        });
      } else if (a == 2) {
        this.$router.push({
          path: "/project",
        });
      } else if (a == 3) {
        this.$router.push({
          path: "/new",
        });
      } else if (a == 4) {
        this.$router.push({
          path: "/business",
        });
      } else if (a == 5) {
        this.$router.push({
          path: "/recruit",
        });
      } else if (a == 6) {
        this.$router.push({
          path: "/contact",
        });
      }
    },
    //tab点击事件
    tab_click(a) {
      console.log(a);
      const _this = this;
      _this.goodsstatus = a;
      _this.defaule = 0;
      var list = _this.details;
      _this.project = list.statusAllVo[a].subList;
      if (list.statusAllVo[a].subList) {
        _this.project_list = list.statusAllVo[a].subList[0].projectlist;
      } else {
        _this.project_list = [];
      }
    },
    //具体项目点击事件
    stuclick(a) {
      const _this = this;
      var goodsstatus = this.goodsstatus;
      var list = _this.details;
      _this.stu = a;
      _this.project_list = list.statusAllVo[goodsstatus].subList[a].projectlist;
    },
    //鼠标移入事件
    enter1(index) {
      var id = index;
      document.getElementById(id).style.display = "block";
    },
    //鼠标移出事件
    leave1(index) {
      document.getElementById(index).style.display = "none";
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/project.vue